import { MRT_ColumnDef } from "material-react-table";
import type { Job } from "../../../../../models";
import { ColumnContext, checkboxColumn } from "./standard-column-types";

export function column_IsTestJob(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return checkboxColumn(context, "isTestJob", "isTestJob");
}

export function column_CollectBoundary(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return checkboxColumn(context, "collectBoundary", "collectBoundary");
}

export function column_ReadyToSample(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return checkboxColumn(context, "isReadyToSample", "isReadyToSample", { groupStateKey: "readySelectionState" });
}
